import React from 'react';
import { T } from '../../../helpers/i18n';
import { Texto } from '../Texto';
export const BlockUser = ({ user, collaboratorName, align, fontSize, bold }) => (React.createElement("div", { style: { width: '100%', textAlign: align } },
    !collaboratorName &&
        React.createElement(Texto, { texto: `${T('sellBy')} ${user}`, align: align, fontSize: fontSize, bold: bold }),
    collaboratorName &&
        React.createElement(Texto, { texto: `${T('sellBy')} ${collaboratorName} - ${user}`, align: align, fontSize: fontSize, bold: bold })));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockUser.tsx
// module id = 508
// module chunks = 0